import React from 'react'
import { CenterBox } from '@repo/ui/components/center-box'
import { Typography } from '@repo/ui/components/typography'
import { useTranslate } from '@repo/shared/hooks'
import { Button } from '@repo/ui/components/button'
import Image from 'next/image'

export const ProjectsEmptyState = ({
  onReset,
  isLoading,
}: {
  onReset: () => void
  isLoading: boolean
}) => {
  const { t } = useTranslate()

  return (
    <CenterBox className=' flex-col gap-lg py-10xl'>
      <Image
        src='/images/search.webp'
        alt='empty-state'
        width={64}
        height={64}
      />
      <Typography
        variant='p'
        size='sm'
        color='text-base-surface-100'
        className='text-center'
      >
        {t('projectsEmptyState_title')}
      </Typography>
      <Button
        variant='fill'
        size='sm'
        color='base'
        className='text-center'
        onClick={onReset}
        disabled={isLoading}
      >
        {t('projectsEmptyState_resetFilters')}
      </Button>
    </CenterBox>
  )
}
